import React, { useEffect, useState, useRef } from 'react';
// Realistic names for LatAm/US/Spain
const NAMES = ['María', 'Laura', 'Ana', 'Sofía', 'Carmen', 'Lucía', 'Valentina', 'Camila', 'Martina', 'Daniela', 'Valeria', 'Julia', 'Alba', 'Paula', 'Noelia', 'Andrea', 'Florencia', 'Carolina', 'Mariana', 'Gabriela', 'Natalia', 'Micaela', 'Romina', 'Julieta', 'Agustina', 'Victoria', 'Rocío', 'Milagros', 'Josefina', 'Elena', 'Carlos', 'Miguel', 'Juan', 'José', 'Diego', 'Mateo', 'Nicolás', 'Lucas', 'Martín', 'Alejandro', 'Daniel', 'Joaquín', 'Tomás', 'Sebastián', 'Gabriel'];
// Target cities/countries
const CITIES = ['Buenos Aires, Argentina', 'Córdoba, Argentina', 'Rosario, Argentina', 'Miami, US', 'Los Ángeles, US', 'Nueva York, US', 'Houston, US', 'Chicago, US', 'Madrid, España', 'Barcelona, España', 'Valencia, España', 'Sevilla, España', 'Ciudad de Panamá, Panamá', 'Ciudad de México, México', 'Guadalajara, México', 'Monterrey, México', 'Quito, Ecuador', 'Guayaquil, Ecuador', 'Lima, Perú', 'Arequipa, Perú', 'La Paz, Bolivia', 'Santa Cruz, Bolivia'];
interface Product {
  title: string;
  editionLabel: string;
  priceText: string;
  thumbnailUrl: string;
}
interface ToastData {
  name: string;
  city: string;
  product: Product;
}
export function RecentPurchaseToast() {
  const [toast, setToast] = useState<ToastData | null>(null);
  const [isVisible, setIsVisible] = useState(false);
  const recentNamesRef = useRef<string[]>([]);
  const productsRef = useRef<Product[]>([]);
  // 1. Scan the DOM for products on mount
  useEffect(() => {
    const scanProducts = () => {
      const foundProducts: Product[] = [];
      // Attempt to find the offer section image and price
      try {
        const offerImage = document.querySelector('#oferta img') as HTMLImageElement;
        const priceElement = document.querySelector('#oferta .text-6xl');
        if (offerImage && priceElement) {
          foundProducts.push({
            title: 'Guía Completa INMUNIDAD TOTAL',
            editionLabel: 'Edición Digital',
            priceText: priceElement.textContent?.trim() || '$37',
            thumbnailUrl: offerImage.src
          });
        }
      } catch (e) {
        // Ignore scanning errors
      }
      productsRef.current = foundProducts;
    };
    scanProducts();
  }, []);
  // 2. Logic to generate a random toast
  const generateRandomToast = () => {
    // Get a name not in the last 10
    let availableNames = NAMES.filter(n => !recentNamesRef.current.includes(n));
    if (availableNames.length === 0) availableNames = NAMES; // Fallback if all used
    const randomName = availableNames[Math.floor(Math.random() * availableNames.length)];
    // Update recent names
    recentNamesRef.current.push(randomName);
    if (recentNamesRef.current.length > 10) {
      recentNamesRef.current.shift();
    }
    const randomCity = CITIES[Math.floor(Math.random() * CITIES.length)];
    let selectedProduct: Product;
    // Use scanned products if available, otherwise fallback distribution
    if (productsRef.current.length > 0) {
      selectedProduct = productsRef.current[Math.floor(Math.random() * productsRef.current.length)];
    } else {
      // Fallback: 70% Physical Book, 30% Digital Edition
      const isPhysical = Math.random() < 0.7;
      selectedProduct = {
        title: 'INMUNIDAD TOTAL',
        editionLabel: isPhysical ? 'Physical Book' : 'Edición Digital',
        priceText: isPhysical ? '$67' : '$37',
        thumbnailUrl: 'https://cdn.magicpatterns.com/uploads/rzcGwWD84Gh6ZaFZeZT5Q2/libroinmunidadtotal.png'
      };
    }
    setToast({
      name: randomName,
      city: randomCity,
      product: selectedProduct
    });
  };
  // 3. Timing and orchestration
  useEffect(() => {
    let timeoutId: NodeJS.Timeout;
    const showToastCycle = () => {
      generateRandomToast();
      setIsVisible(true);
      // Hide after 4 seconds
      timeoutId = setTimeout(() => {
        setIsVisible(false);
        // Schedule next toast between 9 and 15 seconds
        const nextInterval = Math.floor(Math.random() * (15000 - 9000 + 1) + 9000);
        timeoutId = setTimeout(showToastCycle, nextInterval);
      }, 4000);
    };
    // Initial delay of 6 seconds
    timeoutId = setTimeout(showToastCycle, 6000);
    return () => clearTimeout(timeoutId);
  }, []);
  if (!toast) return null;
  return <div className={`fixed bottom-6 left-1/2 -translate-x-1/2 z-50 w-[90%] max-w-sm transition-all duration-500 ease-in-out motion-reduce:transition-none ${isVisible ? 'opacity-100 translate-y-0 pointer-events-auto' : 'opacity-0 translate-y-8 pointer-events-none'}`} data-id="element-416">
      <div className="bg-white rounded-2xl shadow-2xl border border-green-mint/20 p-3 flex items-center gap-4 overflow-hidden relative" data-id="element-417">
        {/* Subtle highlight effect */}
        <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-green-lime to-green-mint" data-id="element-418"></div>

        <div className="w-16 h-16 shrink-0 bg-cream rounded-xl flex items-center justify-center overflow-hidden border border-gray-100" data-id="element-419">
          <img src={toast.product.thumbnailUrl} alt={toast.product.title} className="w-full h-full object-cover" onError={e => {
          // Fallback emoji if image fails to load
          ;
          (e.target as HTMLElement).style.display = 'none';
          (e.target as HTMLElement).parentElement!.innerHTML = '<span class="text-2xl">📚</span>';
        }} data-id="element-420" />
        </div>

        <div className="flex-1 min-w-0" data-id="element-421">
          <p className="text-xs text-text-main/60 mb-1" data-id="element-422">
            <span className="font-bold text-text-main" data-id="element-423">{toast.name}</span> en{' '}
            {toast.city} acaba de comprar:
          </p>
          <p className="font-bold text-sm text-green-deep truncate" data-id="element-424">
            {toast.product.title}
          </p>
          <div className="flex items-center justify-between mt-1" data-id="element-425">
            <span className="text-xs font-medium text-text-main/70 bg-gray-100 px-2 py-0.5 rounded-md" data-id="element-426">
              {toast.product.editionLabel}
            </span>
            <span className="text-sm font-bold text-orange-warm" data-id="element-427">
              {toast.product.priceText}
            </span>
          </div>
        </div>
      </div>
    </div>;
}